<template>
  <div class="main-wrapper">
    <div class="client-info-valid">
      <p>
        <span :class="actualInformation ? 'valid-field' : 'unvalid-field'"
          >➤</span
        >
        Отправляя вышеизложенную информацию в Банк,
        {{ isIP ? "индивидуальный предприниматель" : "организация" }}
        подтверждает, что:<br />
        - указанная информация является достоверной, актуальной и полной;
        <br />-
        {{
          isIP
            ? "индивидуальный предприниматель проинформирован"
            : "организация проинформирована"
        }}
        о том, что Банк вправе как до приема на обслуживание, так и в процессе
        обслуживания клиента, не раскрывающего информацию о себе, проводить
        тщательное дополнительное изучение его деятельности, в целях соблюдения
        положительной репутации Банка; Банк не проводит операции со средствами
        сомнительного или криминального происхождения, не оказывает поддержки
        деятельности, выходящей за рамки закона; Банк не принимает участия в
        сложных или нестандартных операциях клиентов без выяснения их
        экономического содержания.
      </p>
      <label>
        <input
          type="checkbox"
          v-model="actualInformation"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('ACTUAL_N_FULL_INFO_AGREE') != -1
          "
        />ДА
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "TakeFinalInformation",
  props: {
    pageName: String,
    pageInfo: {},
    bankName: String,
    isIP: Boolean,
  },
  data: () => ({
    actualInformation: false,
    sendData: {},
  }),
  methods: {
    validation() {
      var msg = "";
      if (!this.actualInformation)
        msg +=
          "Необходимо заполнить поля:<br>• Клиент подтверждает, что информация является достоверной, актуальной и полной<br>";

      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.sendData.ACTUAL_N_FULL_INFO_AGREE = this.actualInformation;
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    if (
      this.pageInfo.ACTUAL_N_FULL_INFO_AGREE != null &&
      !this.actualInformation
    )
      this.actualInformation = this.pageInfo.ACTUAL_N_FULL_INFO_AGREE;
    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
.necessary {
  color: red;
}
</style>
